import React from "react";
import { Card, UserCog } from "../../../ui";
import { APPS, tx } from "../../ludConnect.constants";
import "./AdminApps.css";
import { AtSign, Lock, QrCode } from "lucide-react";

// Read-only view of the restaurant-level admin accounts per delivery app.
const AdminApps = ({ ar, restaurant }) => {
  const configured = APPS.filter((app) => restaurant.adminApps?.[app.id]);

  return (
    <Card
      title={
        <span>
          <UserCog size={16} /> {tx("أدمن التطبيقات", "Application admins", ar)}{" "}
          <em>
            — {tx("حسابات على مستوى المطعم", "Restaurant-level accounts", ar)}
          </em>
        </span>
      }
      hoverable={false}
      className="lud-connect__section-card"
    >
      {configured.length ? (
        <div className="lud-connect__admin-grid">
          {configured.map((app) => {
            const data = restaurant.adminApps[app.id];
            return (
              <div className="lud-connect__admin-row" key={app.id}>
                <div>
                  <b>{ar ? app.name : app.nameEn}</b>
                  {data.status && (
                    <span className={`lud-connect__status ${data.status}`}>
                      {data.status}
                    </span>
                  )}
                </div>
                <div className="lud-connect__branch-info">
                  <div title={tx("المعرف", "ID", ar)}>
                    <QrCode size={14} aria-hidden="true" />
                    <span>{data.credId || "-"}</span>
                  </div>
                  <div title={tx("الإيميل", "Email", ar)}>
                    <AtSign size={14} aria-hidden="true" />
                    {data.email || "—"}
                  </div>
                  <div title={tx("الرقم السري", "Password", ar)}>
                    <Lock size={14} aria-hidden="true" />
                    {data.pass || "—"}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="lud-connect__muted">
          {tx(
            "لا يوجد تطبيقات مُضافة كأدمن لهذا المطعم",
            "No admin applications have been added for this restaurant",
            ar,
          )}
        </div>
      )}
    </Card>
  );
};

export default AdminApps;
